module.exports = __webpack_public_path__ + "img/product-preview-1.b8fbe87.png";